export default __webpack_public_path__ + "assets/e54059095fe2fa943a544ded51b2aeca.svg";